<template>
  <div id="footer">
    <!--联系我们-->
    <div class="contact-us">
      <img :src="contactusImg">
      <div class="footer-text">
        <div class="footer-text-head">留言咨询，为您打造贴身安全解决方案</div>
        <div class="footer-text-content">专业的解决方案、先进的产品帮您解决大数据安全问题，让您无后顾之忧。扎根行业，做各行业用户可信赖的合作伙伴！</div>
      </div>
      <div class="footer-button"><span @click="message($event)">立即咨询</span></div>
    </div>
    <!-- PC底部 -->
    <div class="footPC">
      <div class="content">
        <div class="footPCt1">
          <ul class="colorfff">
            <li>
              <dl>
                <dt>产品服务</dt>
                <dd v-for="(item,index) in solutionCateList" :key="index"><a href="javascript:;" @click="footerDetail" data-type="service" :data-id="item.id" :data-name="item.name" data-nav="2">{{item.name}}</a></dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt>解决方案</dt>
                <dd v-for="(item,index) in cateList" :key="index"><a href="javascript:;" @click="footerDetail" data-type="solution" :data-id="item.id" :data-name="item.name" data-nav="2">{{item.name}}</a></dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt>人才招聘</dt>
              </dl>
            </li>
            <li>
              <dl>
                <dt>新闻中心</dt>
              </dl>
            </li>
            <li>
              <dl>
                <dt>关于辰图</dt>
                <dd><a href="javascript:;" @click="footerDetail" data-type="about" data-id="1" data-nav="7">公司概况</a></dd>
                <dd><a href="javascript:;" @click="footerDetail" data-type="about" data-id="1" data-nav="7">专业团队</a></dd>
                <dd><a href="javascript:;" @click="footerDetail" data-type="about" data-id="1" data-nav="7">发展规划</a></dd>
              </dl>
            </li>
          </ul>
          <ul class="phone-us">
            <li>
              <dl>
                <dt>联系我们</dt>
                <dd>联系电话：<span>{{configList.presale_phone}}</span></dd>
                <dd>邮箱：{{configList.presale_email}}</dd>
                <dd>地址：{{configList.address}}</dd>
              </dl>
            </li>
          </ul>
          <span>
            <!-- <img class="wechat-image" :src="base_url+configList.wechat_image"> -->
            <img class="wechat-image" :src="img_url + configList.wechat_image">
            <p>关注公众号</p>
          </span>
        </div>
        <div class="cc"></div>
        <div class="footPCt2">
          <p>{{configList.copyright}}&nbsp;&nbsp;&nbsp;&nbsp; {{configList.icp_num}}</p>
        </div>
      </div>
    </div>
    <!-- 手机底部 -->
    <div class="footMOB">
      <div class="content">
        <p>{{configList.copyright}}&nbsp;&nbsp;&nbsp;&nbsp; {{configList.icp_num}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  var CONFIG = require('@/common/config.js');
  var base_url = CONFIG.API_URL.BASE_URL;
  var img_url = CONFIG.API_URL.IMG_URL;

  export default {
    data () {
      return {
        base_url: base_url,//base_url
        img_url: img_url,
        solutionCateList: [],//解决分类列表
        cateList: [],
        caseCateList: [],//案例分类列表
        configList: [],//配置信息列表
        contactusImg: '../../static/images/Image 3.png',
      }
    },
    created: function () {
      var that = this;

      //获取解决分类列表
      that.getSolutionCateList();

      //获取案例分类列表
      that.getCaseCateList();

      //获取配置信息列表
      that.getConfigList();

      //获取配置信息列表
      that.getCateList();
    },
    methods: {
      //获取解决分类列表
      getSolutionCateList:function(){
        var that = this;
        axios.post(base_url+'front/getInfoCateList', {'type': 1}).then(function (res) {
          //console.log(res);
          if(res.data.code == 0){
            var dataList = res.data.result;
            that.solutionCateList = dataList;
          }
        }).catch(function (err) {
          //console.log(err);
        })
      },

      //获取解决分类列表
      getCateList:function(){
        var that = this;
        axios.post(base_url+'front/getInfoCateList', {'type': 2}).then(function (res) {
          //console.log(res);
          if(res.data.code == 0){
            var dataList = res.data.result;
            that.cateList = dataList;
          }
        }).catch(function (err) {
          //console.log(err);
        })
      },

      //留言
      message:function($event){
        var that = this;
        that.$router.push({ path: '/message'});
      },

      //获取案例分类列表
      getCaseCateList:function(){
        var that = this;
        axios.post(base_url+'front/getInfoCateList', {'type': 3}).then(function (res) {
          //console.log(res);
          if(res.data.code == 0){
            var dataList = res.data.result;
            that.caseCateList = dataList;
          }
        }).catch(function (err) {
          //console.log(err);
        })
      },

      //获取配置信息
      getConfigList:function(){
        var that = this;
        axios.post(base_url+'front/getConfigList', {'group': null}).then(function (res) {
          // console.log(res);
          if(res.data.code == 0){
            var dataList = res.data.result;
            var configList = [];
            for (var i=0;i<dataList.length;i++) {
              var itemKey = dataList[i]['itemKey'];
              var itemValue = dataList[i]['itemValue'];
              configList[itemKey] = itemValue;
            }
            // console.log(configList);
            that.configList = configList;
          }
        }).catch(function (err) {
          //console.log(err);
        })
      },



      //Footer详情
      footerDetail:function(e){
        var that = this;
        var type = e.currentTarget.dataset.type;
        var id = e.currentTarget.dataset.id;
        if(type == "solution"){//解决方案
          var name = e.currentTarget.dataset.name;
          that.$router.push({ path: '/solution?id='+id+'&name='+name });

        }else if(type == "service"){//服务支持
          that.$router.push({ path: '/service?id='+id });

        }else if(type == "cases"){//客户案例
          that.$router.push({ path: '/cases' });

        }else if(type == "about"){//公司简介
          that.$router.push({ path: '/about' });

        }else if(type == "contact"){//联系我们
          that.$router.push({ path: '/contact' });

        }else if(type == "join"){//加入我们
          that.$router.push({ path: '/join' });

        }
        //储存导航标识
        var nav = e.currentTarget.dataset.nav;
        localStorage.setItem("navIndex",nav);
      },

    }
  }
</script>

<style scoped>
  @import url("./footer.css");
</style>



// WEBPACK FOOTER //
// src/views/inner/footer/footer.vue